var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectWalletWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73553 4.33776C10.2974 -0.117794 17.7026 -0.117794 22.2645 4.33776L22.8137 4.87809C23.044 5.09954 23.044 5.46272 22.8137 5.68417L20.9358 7.51777C20.8206 7.63292 20.6346 7.63292 20.5195 7.51777L19.7665 6.78255C16.5777 3.67341 11.4223 3.67341 8.23347 6.78255L7.4274 7.57091C7.31224 7.68607 7.12623 7.68607 7.01107 7.57091L5.13319 5.73732C4.90288 5.51587 4.90288 5.15269 5.13319 4.93124L5.73553 4.33776ZM26.1531 8.12896L27.8273 9.75883C28.0576 9.98028 28.0576 10.3435 27.8273 10.5649L20.2892 17.9259C20.0588 18.1473 19.6868 18.1473 19.4654 17.9259L14.1152 12.6997C14.062 12.6465 13.9646 12.6465 13.9114 12.6997L8.56122 17.9259C8.33091 18.1473 7.95887 18.1473 7.73742 17.9259L0.17273 10.5649C-0.0575767 10.3435 -0.0575767 9.98028 0.17273 9.75883L1.84688 8.12896C2.07719 7.90751 2.44923 7.90751 2.67068 8.12896L8.02088 13.3552C8.07403 13.4083 8.17146 13.4083 8.22461 13.3552L13.5748 8.12896C13.8051 7.90751 14.1772 7.90751 14.3986 8.12896L19.7488 13.3552C19.802 13.4083 19.8994 13.4083 19.9526 13.3552L25.3028 8.12896C25.5508 7.90751 25.9228 7.90751 26.1531 8.12896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWalletWhite);
export default __webpack_public_path__ + "static/media/connectWallet-white.339fec16b63ccd054eda915a8df9e002.svg";
export { ForwardRef as ReactComponent };